/** One extra editor column (primary column is built separately in {@link AppShell}). */
export type MultiviewExtraSlot = {
  sash: HTMLDivElement;
  column: HTMLDivElement;
  header: HTMLDivElement;
  editorHost: HTMLDivElement;
  editor: HTMLTextAreaElement;
  lineNumberGutter: HTMLDivElement;
  lineNumberPre: HTMLPreElement;
  highlightPre: HTMLPreElement;
  highlightCode: HTMLElement;
};

export const MULTIVIEW_MAX_PANES = 8;
/** Extra columns = max panes minus primary. */
export const MULTIVIEW_MAX_EXTRA = MULTIVIEW_MAX_PANES - 1;

export function createMultiviewExtraSlot(slotIndex: number): MultiviewExtraSlot {
  const sash = document.createElement("div");
  sash.className = "npp-multiview-sash";
  sash.setAttribute("role", "separator");
  sash.setAttribute("aria-orientation", "vertical");
  sash.dataset.multiviewSashSlot = String(slotIndex);
  sash.title = "Resize (two panes only)";

  const column = document.createElement("div");
  column.className = "npp-multiview-extra-col";
  column.dataset.multiviewExtraSlot = String(slotIndex);

  const header = document.createElement("div");
  header.className = "npp-multiview-slot-header";
  header.dataset.multiviewSlot = String(slotIndex);
  header.textContent = "—";
  header.title = "Click to target this column, then Alt+click a tab (plain text) to assign.";

  const editorHost = document.createElement("div");
  editorHost.className = "npp-editor-host";

  const highlightPre = document.createElement("pre");
  highlightPre.className = "npp-editor-highlight";
  const highlightCode = document.createElement("code");
  highlightPre.appendChild(highlightCode);

  const lineNumberGutter = document.createElement("div");
  lineNumberGutter.className = "npp-line-number-gutter";
  const lineNumberPre = document.createElement("pre");
  lineNumberPre.className = "npp-line-number-pre";
  lineNumberGutter.appendChild(lineNumberPre);

  const editor = document.createElement("textarea");
  editor.className = "npp-editor";
  editor.spellcheck = false;
  editor.placeholder = "Click column title, then Alt+click a tab to assign a file";
  editor.dataset.multiviewEditorSlot = String(slotIndex);

  editorHost.append(lineNumberGutter, highlightPre, editor);
  column.append(header, editorHost);

  return {
    sash,
    column,
    header,
    editorHost,
    editor,
    lineNumberGutter,
    lineNumberPre,
    highlightPre,
    highlightCode,
  };
}
